module.exports = __webpack_public_path__ + "img/59400.0186b624.jpg";